export default __webpack_public_path__ + "static/media/a1.79db31b0.png";